import React from "react";
import PropTypes from "prop-types";
import { CSSTransitionGroup } from "react-transition-group";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

const AnimatedLocations = ({
	transitionName,
	transitionEnterTimeout,
	transitionLeaveTimeout,
	children,
	showAnimation,
}) => (
	<Router>
		<Route
			render={(props) => {
				// eslint-disable-next-line react/prop-types
				const { location } = props;

				return showAnimation ? (
					<CSSTransitionGroup
						transitionName={transitionName}
						transitionEnterTimeout={transitionEnterTimeout}
						transitionLeaveTimeout={transitionLeaveTimeout}
					>
						{/* eslint-disable-next-line react/prop-types */}
						<div key={location.key}>
							<Switch location={location}>
								{children}
							</Switch>
						</div>
					</CSSTransitionGroup>
				) : (
					<Switch location={location}>
						{children}
					</Switch>
				);
			}}
		/>
	</Router>
);

AnimatedLocations.propTypes = {
	transitionName: PropTypes.string.isRequired,
	transitionEnterTimeout: PropTypes.number.isRequired,
	transitionLeaveTimeout: PropTypes.number.isRequired,
	children: PropTypes.any.isRequired,
	showAnimation: PropTypes.bool,
};

AnimatedLocations.defaultProps = {
	showAnimation: true,
};

export default AnimatedLocations;



// WEBPACK FOOTER //
// ./src/shared/components/AnimatedLocations.jsx